import React from 'react'
import { storiesOf } from '@storybook/react'
import { withKnobs, boolean, text } from '@storybook/addon-knobs/react'

import ActionContext from 'components/ActionContext'

const stories = storiesOf('ActionContext', module)
stories.addDecorator(withKnobs)

const Component = () => <div>Content</div>

stories
  .add('interactive', () => {
    const isLoading = boolean('isLoading', true)
    const errorCode = text('errorCode', undefined)

    return (
      <ActionContext componentProps={{}} isLoading={isLoading} errorCode={errorCode} component={Component} />
    )
  })
  .add('loading', () => {
    return (
      <ActionContext componentProps={{}} isLoading component={Component} />
    )
  })
  .add('error', () => {
    return (
      <ActionContext componentProps={{}} errorCode="Something bad happened." component={Component} />
    )
  })
  .add('okay', () => {
    return (
      <ActionContext componentProps={{}} component={Component} />
    )
  })
